import { useEffect, useState } from "react";

const LINES = [
    { prompt: "$", text: "synapselink 3000", typed: true },
    { prompt: "▸", text: "SynapseLink v1.0.2 — establishing secure relay…", typed: false, color: "text-[#52525B]" },
    { prompt: "▸", text: "Authenticating with API key …………… [ ok ]", typed: false, color: "text-[#52525B]" },
    { prompt: "▸", text: "Reserving persistent subdomain …………… [ ok ]", typed: false, color: "text-[#52525B]" },
    { prompt: "▸", text: "WSS handshake → relay-iad-01 …………… [ ok ]", typed: false, color: "text-[#52525B]" },
    { prompt: "", text: "", typed: false },
    { prompt: "", text: "  Forwarding   localhost:3000 → ", trailing: "https://staging-api.synapselink.cloud", color: "text-[#FAFAFA]", trailColor: "text-[#00FF41]" },
    { prompt: "", text: "  Inspector    https://synapselink.cloud/app/tunnels/staging-api", color: "text-[#FAFAFA]" },
    { prompt: "", text: "  Status       online · 0 connections · 0ms p95", color: "text-[#FAFAFA]" },
    { prompt: "", text: "", typed: false },
    { prompt: "▸", text: "GET  /api/users     200  41ms", color: "text-[#00FF41]" },
    { prompt: "▸", text: "POST /webhooks/stripe 200  88ms", color: "text-[#FF9900]" },
];

export default function TerminalAnimation() {
    const [step, setStep] = useState(0); // line index
    const [typed, setTyped] = useState(""); // typed chars for line 0

    // Type the first command
    useEffect(() => {
        if (step !== 0) return;
        const target = LINES[0].text;
        if (typed.length >= target.length) {
            const t = setTimeout(() => setStep(1), 450);
            return () => clearTimeout(t);
        }
        const t = setTimeout(() => setTyped(target.slice(0, typed.length + 1)), 70);
        return () => clearTimeout(t);
    }, [typed, step]);

    // Reveal subsequent lines progressively
    useEffect(() => {
        if (step === 0 || step >= LINES.length) return;
        const delay = LINES[step]?.text === "" ? 200 : 380;
        const t = setTimeout(() => setStep(step + 1), delay);
        return () => clearTimeout(t);
    }, [step]);

    return (
        <div className="relative bg-[#0A0A0A] border border-[#27272A] overflow-hidden scanlines crt-flicker noise" data-testid="terminal-animation">
            {/* Title bar */}
            <div className="flex items-center justify-between border-b border-[#27272A] px-4 py-2.5 bg-[#050505]">
                <div className="flex items-center gap-2">
                    <span className="w-3 h-3 bg-[#FF3B30]"></span>
                    <span className="w-3 h-3 bg-[#FF9900]"></span>
                    <span className="w-3 h-3 bg-[#00FF41]"></span>
                </div>
                <span className="label-mono text-[#52525B] text-[10px]">~ /synapselink — bash</span>
                <span className="label-mono text-[#52525B] text-[10px]">80×24</span>
            </div>

            {/* Body */}
            <div className="p-6 sm:p-8 font-mono text-[13px] sm:text-[14px] leading-relaxed min-h-[360px]">
                {/* line 0: command */}
                <div className="flex">
                    <span className="text-[#00FF41] mr-3">$</span>
                    <span className="text-[#FAFAFA]">
                        {step === 0 ? typed : LINES[0].text}
                        {step === 0 && <span className="cursor-block"></span>}
                    </span>
                </div>

                {LINES.slice(1).map((line, i) => {
                    const idx = i + 1;
                    if (step <= idx) return null;
                    if (line.text === "" && !line.trailing) return <div key={idx} className="h-3" />;
                    return (
                        <div key={idx} className="flex flex-wrap">
                            {line.prompt && <span className="text-[#52525B] mr-3">{line.prompt}</span>}
                            <span className={line.color || "text-[#A1A1AA]"}>{line.text}</span>
                            {line.trailing && (
                                <a className={`underline underline-offset-2 ${line.trailColor || "text-[#00FF41]"}`} href="#">
                                    {line.trailing}
                                </a>
                            )}
                        </div>
                    );
                })}

                {step >= LINES.length && (
                    <div className="mt-4 flex">
                        <span className="text-[#00FF41] mr-3">$</span>
                        <span className="cursor-block text-transparent">_</span>
                    </div>
                )}
            </div>
        </div>
    );
}
